import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';

class WhyShopee extends React.Component {
  render() {
    const { list = [], canAnimation = true } = this.props;
    return (
      <>
        <ul className="info-list-wrapper">
          {
            list.map((item, index) => (
              <ReactWOW animation={canAnimation ? 'fadeInUp' : ''} delay={`${index * 0.1}s`} key={item.title || index}>
                <li className="introduce-item">
                  { item.img ? <img className="img" src={item.img} alt={item.img} /> : null }
                  <div className="content">
                    <p className="title">{$t(item.title)}</p>
                    {
                      Array.isArray(item.desc)
                      ? item.desc.map(desc => <p className="paragraph" key={desc}>{$t(desc)}</p>)
                      : <p className="paragraph">{$t(item.desc)}</p>
                    }
                  </div>
                </li>
              </ReactWOW>
            ))
          }
        </ul>
      </>
    );
  }
}

export default WhyShopee;
